angular.module('fundersclub.legaldocs', [
    'fundersclub.models',
]);
